import colors from 'styles/colors'

export const styles = {
  icon: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 30,
    height: 30,
    fontSize: 30,
    color: colors.primary
  }
}
